import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import {ModalHeader, ModalContent, ModalFooter,ContentItem} from '@gnb/components/Common'
import PreferenceContentTemplate from '@gnb/templates/PreferenceContentTemplate.vue'
import StorageView from '@gnb/components/Preference/Mail/Storage/StorageView.vue'
import DatePicker from '@appbase/components/DatePicker/DatePicker.vue'
import { ModalLayout } from '@appbase/templates'
import PopupModal from '@gnb/components/Common/PopupModal.vue'
import { FormGroup, TextBoxField } from '@appbase/components/forms'
import RecipientField from '@gnb/components/Common/RecipientField.vue';
import CheckSlider from '@gnb/components/Common/CheckSlider.vue'
import api from '@gnb/api/common'

@Component({
    components:{
        PopupModal,
        ModalLayout,
        ModalHeader,
        ModalContent,
        ModalFooter,
        ContentItem,
        PreferenceContentTemplate,
        StorageView,
        DatePicker,
        FormGroup,
        TextBoxField,
        RecipientField,
        CheckSlider
    }
})
export default class MultiAccountModal extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({type: Object}) value!: gnb.multiMail;
    @Prop({type: Boolean}) show!: false;
    @Prop({type: Object}) tempRecipients!: orgmap.UserItem;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    requiredRecipients: orgmap.UserItem[] = [];
    title: string = '';
    buttonTitle: string = '';
    tempMultiList: gnb.multiMail = {} as gnb.multiMail;

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
 
    @Watch('value')
    onChangedValues(){
        if(this.value && this.value.personCode){
            api.getUserByPersonCode(this.value.personCode).then((res:any)=>{
                this.requiredRecipients = [res];
            });
        }
        if(this.value.id){
            this.title='계정 수정'
            this.buttonTitle = '수정'
        }else{
            this.title='새 계정 추가';
            this.buttonTitle = '저장'
        }
    }

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //
    
    get placeholder(){
        if(this.requiredRecipients.length > 0){
            return null;
        }else{
            return '멀티계정 대상을 입력하세요.';
        }
    } 
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    validateEmail(value: string){
        const emailRegex = new RegExp(`^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$`)
        if (!emailRegex.test(value) && value.length > 0) {
            return { succeed: false, reason: 'invalid' }
        }else{
            return { succeed: true }
        }
    }

    async save(){
        if(this.requiredRecipients.length < 1){
            await(window as any).alertAsync('멀티계정을 사용할 사용자를 선택해주세요');
            return false;
        }else{
            this.value.personCode = this.requiredRecipients[0].personCode;
            let validate = this.validateEmail(this.value.email)
            if(validate.succeed === true){
                this.$emit('save');
                this.requiredRecipients = [];
            }else{
                await(window as any).alertAsync('이메일 형식이 올바르지 않습니다. 이메일 형식을 확인해주세요.')
            }
        }
    }

    async getUserItem(email:string){
        return await api.getUserInfoByEmail(email).then((res)=>{
            return <orgmap.UserItem>{
                displayName: res.items[0]?.displayName,
                titleName: res.items[0]?.titleName,
                deptName: res.items[0]?.deptName,
                email: res.items[0]?.email  
            }   
        });
    }

    created(){
        this.tempMultiList = this.value;
    }

  
}